import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { useNavigate } from 'react-router-dom';
import { connect } from "react-redux";
import { UpdateLang } from "_actions";
import { logout } from "_actions";
// Swiper CSS'lerini import et
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

const BannerCarouselV3 = (props, { banners = [] }) => {
  const navigate = useNavigate();
  const { currentLang } = props;

  const handleBannerClick = (path) => {
    if (path) {
      navigate(path);
    }
  };
  const _banners = [
    {
      id: 1,
      img: require(`../../../assets/img/banners/kurdo/${currentLang}/slot.jpg`),
      gradient: "from-blue-600 to-blue-800",
      path: "/casino"
    },
    {
      id: 2,
      img: require(`../../../assets/img/banners/kurdo/${currentLang}/casino.jpg`),

      gradient: "from-secondary-600 to-secondary-800",
      path: "/live-casino"
    },
    {
      id: 3,
      img: require(`../../../assets/img/banners/kurdo/${currentLang}/virtual.jpg`),

      gradient: "from-green-600 to-green-800",
      path: "/virtual"
    },
    {
      id: 4,
      img: require(`../../../assets/img/banners/kurdo/${currentLang}/sport.jpg`),

      gradient: "from-purple-600 to-purple-800",
      path: "/"

    },
    {
      id: 5,
      img: require(`../../../assets/img/banners/kurdo/${currentLang}/help.jpg`),

      gradient: "from-purple-600 to-purple-800",
      path: "/"

    },
    {
      id: 6,
      img: require(`../../../assets/img/banners/kurdo/notice.jpg`),

      gradient: "from-purple-600 to-purple-800",
      path: "/"

    }
  ];

  return (
    <div key={currentLang+"bannerv2"} className="bg-[#ffffff17] md:bg-transparent relative mb-0 mt-0 md:mt-4  p-0 md:p-4 overflow-hidden max-w-screen-lg mx-auto">
      <Swiper
        modules={[Autoplay, Pagination, Navigation]}
        spaceBetween={0}
        slidesPerView={1}
        loop={true}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
          dynamicBullets: true,
        }}
        navigation={{
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }}
        className="h-48 md:h-64 rounded-0  md:rounded-xl"
      >
        {_banners.map((banner) => (
          <SwiperSlide key={banner.id}>
            <div
              className={`h-full bg-transparent relative cursor-pointer`}
              onClick={() => handleBannerClick(banner.path)}
            >
              <div className="absolute inset-0 bg-black opacity-50"></div>

              <div
                key={banner.id + currentLang}
                style={{ background: `url(${banner.img})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}
                className="relative z-10 p-4 h-full w-full bg-contain bg-center flex flex-col justify-center bg-no-repeat">

              </div>
              {
                /*
                   <div
                    style={{ backgroundImage: `url(${require('../../../assets/img/f45b.png')})`, bottom: 20, left: 0 }}
                    className="absolute z-20 h-8 w-full bg-contain bg-left bg-no-repeat">
                  </div>
                */
              }
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};



const mapStateToProps = (state, props) => {
  const { authentication, game } = state;
  const { user, loggedIn, currentLang } = authentication;
  const { sports, games } = game;
  return {
    user,
    loggedIn,
    sports,
    games,
    currentLang,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(logout()),
    UpdateLang: (data) => dispatch(UpdateLang(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BannerCarouselV3);
